<template>
  <div class="front"
  :class="{'nav--open': navOpen}">
    <div class="front__header">
      <div class="front__row1"></div>
      <div class="front__row2"></div>
      <div class="front__container">
        <div class="front__logo">
          <a href="#" @click="go_page('/')">
            <img src="@/assets/header_logo.png" alt="回到首頁">
          </a>
        </div>
        <div class="front__cart">
          <a href="#" @click.prevent="cartOpen = true;">
            <img src="@/assets/icon/cart.png" alt="購物車"
            class="front__cart__empty"
            v-if="cart.products.length === 0">
            <img src="@/assets/icon/cart_hover.png" alt="購物車"
            class="front__cart__empty--hover"
            v-if="cart.products.length === 0">
            <img src="@/assets/icon/cart_item.png" alt="購物車"
            class="front__cart__full"
            v-if="cart.products.length !== 0">
            <img src="@/assets/icon/cart_item_hover.png" alt="購物車"
            class="front__cart__full--hover"
            v-if="cart.products.length !== 0">
          </a>
        </div>
        <div class="front__hamburger">
          <a href="#" @click.prevent='navOpen = !navOpen;'>
            <img src="@/assets/icon/main_menu_hamburger.png"
            alt="打開頁面導覽"
            class="front__hamburger--folded">
            <img src="@/assets/icon/close_menu.png"
            alt="關閉頁面導覽"
            class="front__hamburger--cross">
          </a>
        </div>
        <div class="front__nav--rwdM" v-if="navOpen">
          <slide-nav
          :parent='`front__nav--rwdM`'
          :data='headerNavData'>
          </slide-nav>
        </div>
        <div class="front__nav--rwdL">
          <ul class="list">
            <li class="list__item"
            v-for="(item, index) in headerNavData"
            :key="index">
              <a href="#" class="list__a"
              :class="{active: headerNavActive(item.route)}"
              @click="go_page(item.route)">
                <span class="list__chinese">
                  {{item.chinese}}
                </span>
                <span class="list__english">
                  {{item.english}}
                </span>
              </a>
            </li>
          </ul>
        </div>
        <ul class="front__sharelinks">
          <li class="front__sharelinks__item">
            <a href="#">
              <img src="@/assets/icon/main_menu_fb.png" alt=""
              class="front__sharelinks__img">
              <img src="@/assets/icon/main_menu_fb_hover.png" alt=""
              class="front__sharelinks__img--hover">
            </a>
          </li>
          <li class="front__sharelinks__item">
            <a href="#">
              <img src="@/assets/icon/main_menu_line.png" alt=""
              class="front__sharelinks__img">
              <img src="@/assets/icon/main_menu_line_hover.png" alt=""
              class="front__sharelinks__img--hover">
            </a>
          </li>
          <li class="front__sharelinks__item">
            <a href="#">
              <img src="@/assets/icon/main_menu_ig.png" alt=""
              class="front__sharelinks__img">
              <img src="@/assets/icon/main_menu_ig_hover.png" alt=""
              class="front__sharelinks__img--hover">
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="front__banner">
      <img src="@/assets/a8725cb076653957a52d4079b6465679.jpg" alt="">
    </div>
    <div class="front__category">
      <div class="front__container front__category__h100">
        <slide-nav
          :parent='`front__category`'
          :data='categoryData'>
          </slide-nav>
      </div>
    </div>
    <div class="front__category--backupSpace"></div>
    <!-- <div class="testblock"></div> -->
    <div class="front__container">
      <router-view />
    </div>
    <div class="front__footer">
      <div class="front__container front__footer--df">
        <div class="front__map">
          <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.822785427064!2d121.50976601537883!3d25.040087444200456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a90a8d497325%3A0x2876dc1b4d647f9!2z5Lit6I-v5rCR5ZyL57i957Wx5bqc!5e0!3m2!1szh-TW!2stw!4v1611039510591!5m2!1szh-TW!2stw"
          frameborder="0"
          style="border:0;"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"></iframe>
        </div>
        <div class="front__footerInfo">
          <div class="front__footerInfo__logo">
            <img src="@/assets/location_logo.png" alt="">
          </div>
          <ul class="contacts">
            <li class="contacts__item">
              <a href="#" class="contacts__a">
                Tel: (02) 1234-5678
              </a>
            </li>
            <li class="contacts__item">
              <a href="#" class="contacts__a">
                Line: @lineme.com
              </a>
            </li>
            <li class="contacts__item">
              <a href="#" class="contacts__a">
                Mail: service@floraldesign.com
              </a>
            </li>
            <li class="contacts__item">
              <p class="contacts__p">
                100台北市中正區重慶南路一段122號
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="front__copyright">
      <p>COPYRIGHT FLORALDESIGN © ALL RIGHTS RESERVED.</p>
    </div>
    <div class="front__goTop">
      <a href="#" @click.prevent='goTop'>
        <img src="@/assets/icon/top.png" alt="">
      </a>
    </div>
    <div class="front__cartComponent">
      <transition name="fade">
        <cart
        v-if="cartOpen"
        :cart='cart'
        ></cart>
      </transition>
    </div>
    <div class="front__fbMessenger">
      <div id="fb-root"></div>
      <div class="fb-customerchat"
      attribution=setup_tool
      page_id="116243833615369"
      theme_color="#c59d5f"
      logged_in_greeting="Hi! How can we help you?"
      logged_out_greeting="Hi! How can we help you?">
      </div>
    </div>
    <div class="front__goToBack">
      <a href="#" class="myBtn myBtn--info"
      @click="go_page('/adminLogin')">進入後台</a>
    </div>
    <!-- <a href="#" class="testBtn"
    @click.prevent='go_page("/front/test")'>test</a> -->
  </div>
</template>

<script>
import $ from 'jquery';
import slideNav from '@/components/SlideNav.vue';
import cart from '@/components/Cart.vue';

export default {
  components: {
    slideNav,
    cart,
  },
  data() {
    return {
      cart: {
        sum: 0,
        products: [
          // {
          //   img: '',
          //   title: '',
          //   id: '',
          //   price: 0,
          //   quantity: 0,
          // },
          {
            img: require('@/assets/UG061/1074722c095c5d6c66ce6235a56cb4b1.jpg'),
            title: '黃色鬱金香',
            id: 'UG061',
            price: 999,
            quantity: 3,
          },
          {
            img: require('@/assets/PH004/894480a22d67a46a9b8b6a256f9af6e9.jpg'),
            title: '水蜜桃禮盒',
            id: 'PH004',
            price: 2680,
            quantity: 1,
          },
        ],
      },
      navOpen: true,
      cartOpen: false,
    };
  },
  computed: {
    headerNavData() {
      const arr = this.$router.options.routes
        .find((item) => item.name === 'Front').children
        .filter((item) => item.onNav === true)
        .map((item) => {
          const newObj = {};
          /* eslint-disable */
          item.path = item.path === 'onlinestore' ? 'onlinestore/all' : item.path;
          /* eslint-enable */
          newObj.route = `/front/${item.path}`;
          newObj.english = item.name;
          newObj.chinese = item.chinese;
          return newObj;
        });
      return arr;
    },
    categoryData() {
      let arr;
      this.$bus.$on('son_get_data', (data) => {
        arr = data.products;
      });
      this.$bus.$emit('son_call_data');
      arr = arr.map((item) => item.category).flat(2)
        .map((item) => JSON.stringify(item));
      arr = [...new Set(arr)]
        .sort()
        .map((item) => JSON.parse(item))
        .map((item) => {
          const newObj = {};
          newObj.chinese = item.chinese;
          newObj.route = `/front/onlinestore/${item.english}`;
          return newObj;
        });
      const categoryAll = {
        chinese: '全部',
        route: '/front/onlinestore/all',
      };
      arr.splice(0, 0, categoryAll);
      return arr;
    },
  },
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
    goTop() {
      $('html').animate({
        scrollTop: 0,
      });
    },
    sumCart() {
      this.cart.sum = 0;
      this.cart.products.forEach((item) => {
        this.cart.sum += item.price * item.quantity;
      });
    },
    headerNavActive(route) {
      return this.$route.path.includes(route);
    },
  },
  created() {
    this.$bus.$on('toggleCart', (boolean) => {
      this.cartOpen = boolean;
    });
    this.$bus.$on('editCart', () => {
      this.sumCart();
    });
    this.$bus.$on('call_cart', () => {
      this.$bus.$emit('get_cart', this.cart);
    });
    this.$bus.$on('add_to_cart', (product) => {
      const theProduct = JSON.parse(JSON.stringify(product));
      const hasProduct = this.cart.products.find((item) => item.id === theProduct.id) !== undefined;
      if (hasProduct) {
        const cartProduct = this.cart.products.find((item) => item.id === theProduct.id);
        cartProduct.quantity += theProduct.quantity;
      } else {
        this.cart.products.push(theProduct);
      }
      this.sumCart();
    });
    this.sumCart();
  },
  mounted() {
    const rendorHeaderCategory = () => {
      const windowTop = $(window).scrollTop();
      const headerHeight = 100;
      const categoryTop = 420;

      if (windowTop > 0) {
        $('.front').addClass('header--transparent');
      } else {
        $('.front').removeClass('header--transparent');
      }

      if (windowTop >= categoryTop - headerHeight) {
        $('.front').addClass('category--fixed');
      } else {
        $('.front').removeClass('category--fixed');
      }
    };
    rendorHeaderCategory();
    $(window).scroll(() => {
      rendorHeaderCategory();
    });
  },
};
</script>
